import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgyPhoneInputField from 'app/components/util/lgy-input-field/LgyPhoneInputField'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { contactInformationFormValidator } from 'app/gears/profile/validators/contactInformationFormValidator'
import lgySelectFieldNormalizer from 'app/components/util/lgy-select-field/lgySelectFieldNormalizer'
import { parsePhone, formatPhone } from 'app/utils/fieldUtils'

import '../style/profile.scss'
// TODO: replace isSuccess with redux-form standard params submitSucceeded and submitFailed (and wire them up)
const ContactInformationForm = ({ stationList, validations, handleSubmit, pristine, submitting, user, isSuccess, reset, dispatch, clearMessages, submitSucceeded, submitFailed }) =>
  <div>
    {(!user.primaryPhoneNumber || !user.primaryPhoneNumberType || !user.email || ((user.isAffiliate === false) && !user.userStation))
      && <LgyAlertDialog type='info' heading='Contact Information Required' text='Please fill out your contact information to complete account setup.' />}
    {user.isAffiliate && user.affiliations.length === 0 &&
      <LgyAlertDialog type='error' heading='Affiliate Information Required' text='Please click Affiliation Information on the left and fill out your affiliate information after you complete your contact information to complete account setup.' />}
    <LgySection header='Contact Information' className='contact-information-section'>
      {(isSuccess || submitSucceeded) && <LgyAlertDialog type='success' heading='Profile Updated' text='Your profile information was updated successfully.' />}
      {(user.isAffiliate === false) && !user.userStation && <LgyAlertDialog type='info' heading='User Station Required' text='Please fill out all of the required fields to complete account setup.' />}
      <form onSubmit={handleSubmit}>
        <fieldset>
          <legend className='usa-sr-only'>Contact Information Form</legend>
          <div className='usa-width-one-half'>
            <Field
              name='jobTitle'
              type='text'
              component={LgyInputField}
              label='Job Title'
              maxLength='100'
              autoFocus
            />
            {(user.isAffiliate === false) &&
              <Field
                name='userStation'
                type='select'
                component={LgySelectField}
                label='User Station'
                validate={validations.requiredDropdown}
                normalize={lgySelectFieldNormalizer}
                required>
                {stationList && stationList.map(station =>
                  <option value={station.stationNumber} key={station.stationNumber}> {station.stationCity}</option>)}
              </Field>}
            <Field
              name='email'
              type='text'
              component={LgyInputField}
              label='Work Email'
              tooltip='Please enter your work email address. This does not need to match your ID.me login email. You may receive email from VA LGY at this address. If you change employment, please update this to your new work email.'
              validate={[validations.email, validations.required]}
              maxLength='100'
              required />
          </div>
          <div className='usa-width-one-whole'>
            <div className='usa-width-one-half'>
              <Field
                name='primaryPhoneNumber'
                type='text'
                component={LgyPhoneInputField}
                label='Primary Phone Number'
                format={formatPhone}
                parse={parsePhone}
                validate={[validations.phoneNumber, validations.required]}
                required />
            </div>
            <div className='usa-width-one-half'>
              <Field
                name='primaryPhoneNumberExtension'
                type='text'
                component={LgyInputField}
                label='Extension'
                validate={validations.numeric}
                maxLength='7' />
            </div>
          </div>
          <div className='usa-width-one-half'>
            <Field
              name='primaryPhoneNumberType'
              type='select'
              component={LgySelectField}
              label='Primary Phone Type'
              validate={validations.requiredDropdown}
              required >
              <option value='H'>Home</option>
              <option value='W'>Work</option>
              <option value='C'>Cell</option>
            </Field>
          </div>
          <div className='usa-width-one-whole'>
            <div className='usa-width-one-half'>
              <Field
                name='secondaryPhoneNumber'
                type='text'
                component={LgyPhoneInputField}
                label='Secondary Phone Number'
                format={formatPhone}
                parse={parsePhone}
                validate={[validations.phoneNumber]}
              />
            </div>
            <div className='usa-width-one-half'>
              <Field
                name='secondaryPhoneNumberExtension'
                type='text'
                component={LgyInputField}
                label='Extension'
                validate={validations.numeric}
                maxLength='7' />
            </div>
          </div>
          <div className='usa-width-one-half'>
            <Field
              name='secondaryPhoneNumberType'
              type='select'
              component={LgySelectField}
              label='Secondary Phone Type'>
              <option value='H'>Home</option>
              <option value='W'>Work</option>
              <option value='C'>Cell</option>
            </Field>
          </div>
          <div className='contact-info-buttons usa-width-one-whole'>
            <button className='usa-button lgy-profile-button' type='submit' value='Submit' disabled={submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
          </div>
        </fieldset>
      </form>
    </LgySection>
  </div>

export default reduxForm({
  validate: contactInformationFormValidator
})(ContactInformationForm)
